module.exports = __webpack_public_path__ + "img/verrassing-automaat.92f0cb0a.jpg";